export default {
  alerts: {
    unknown: 'unknown wallet', basis: '24h change', check: '~30 s',
    flow: { inflow: 'exchange deposit', outflow: 'exchange withdrawal' },
    err: { maxNets_one: 'You can choose at most {{count}} network.', maxNets_other: 'You can choose at most {{count}} networks.', enableFirst: 'Turn on OrcaWatch first.' },
    notice: {
      price: 'Price {{price}} · entered the {{level}} level in 24h', test: 'Test', testBody: 'This is what an urgent Orca notification looks like',
      n4: { title: 'Wall Street · Pre-Market', body: 'Futures rise; NVIDIA earnings and the FOMC minutes in focus' },
      n5: { title: 'News on your coins', body: '11 stories · BTC, ETH, SOL, TON, LINK' },
      n6: { title: 'Tomorrow: FOMC minutes', body: 'High impact on BTC, ETH and indices' },
      n7: { title: 'X Radar · 3 important posts', body: 'Vitalik Buterin, Solana, Chainlink — the hourly digest' },
    },
  },
};
